import axios from 'axios';

const fetchAll = ({ params }) => axios.get('v1/users/banks', { params });

export const BanksAPI = { fetchAll };
